import './CreditCardIFrameField.scss'
import React from 'react'
import BEMHelper from 'react-bem-helper'

const bem = new BEMHelper('creditcard-iframe')

export default function CreditCardIFrameField({ id }) {
	return (
		<div {...bem('')}>
			<div id={id} className='hosted-field'></div>
		</div>
	)
}
